
function SelectSocialNetwork({ chooseValue }) {

    return (
        <div className="flex flex-row-reverse items-center mb-4">
            <label for="socialNetwork" className="w-40"> : شبکه اجتماعی</label>
            <select
                className="w-80 drtl bg-white p-1 pr-2 border border-slate-200 rounded"
                id="socialNetwork"
                onChange={(e) => chooseValue(e.target.value)}
            >
                <option value='' selected>همه</option>
                <option value='اینیستاگرام'>اینیستاگرام</option>
                <option value='تلگرام'>تلگرام</option>
                <option value="آپارات">آپارات</option>
                <option value="یوتیوب">یوتیوب</option>
                <option value="وب">وب</option>
            </select>
        </div>
    )
}
export default SelectSocialNetwork;